const RequestType = {
	Disclose: Symbol('disclose'),
	Delete: Symbol('delete'),
	Correct: Symbol('correct'),
	Appeal:Symbol('appeal'),
	DiscloseBehalf: Symbol('disclose-behalf'),
	DeleteBehalf: Symbol('delete-behalf'),
	CorrectBehalf: Symbol('correct-behalf'),
	AppealBehalf:Symbol('appeal-behalf'),
}

export default RequestType;